module.exports = __webpack_public_path__ + "img/mobile-app1.da220061.png";